export const CONSONANTS: string[] = [
  'ก','ข','ค','ฆ','ง','จ','ฉ','ช','ซ','ฌ','ญ','ฎ','ฏ',
  'ฐ','ฑ','ฒ','ณ','ด','ต','ถ','ท','ธ','น','บ','ป','ผ','ฝ','พ',
  'ฟ','ภ','ม','ย','ร','ล','ว','ศ','ษ','ส','ห','ฬ','อ','ฮ',
];

export const VOWELS: string[] = [
  '-ะ', '-า', '-ิ', '-ี', '-ึ', '-ื', '-ุ', '-ู',
  'เ-', 'เ-ะ', 'แ-', 'แ-ะ', 'โ-', 'โ-ะ',
  'เ-าะ', '-อ', 'เ-อะ', 'เ-อ',
  'เ-ียะ', 'เ-ีย', 'เ-ือะ', 'เ-ือ', '-ัวะ', '-ัว',
  'ใ-', 'ไ-', '-ำ', 'เ-า',
  '-รร', 'ฤ', 'ฤๅ',
];
